<template>
  <div>
    <v-dialog v-model="dialog" max-width="1000" persistent scrollable>
      <v-card>
        <v-card-title>
          Selectionner des utilisateurs
          <v-spacer/>
          <v-btn icon @click="close()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider/>

        <v-card-text class="pa-10">
          <v-tabs v-model="tab"
                  color="gifty"
                  centered
          >
            <v-tabs-slider></v-tabs-slider>

            <v-tab href="#tab-1">
              <v-icon left dense>mdi-filter-outline</v-icon>
              Filtrage
            </v-tab>

            <v-tab href="#tab-2" v-if="can('admin')">
              <v-icon left dense>mdi-account-multiple-outline</v-icon>
              Utilisateurs
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab">
            <v-tab-item value="tab-1">
              <v-card>
                <v-card-text>
                  <form @submit.prevent="filterUsers">

                    <v-row>
                      <v-col cols="6">
                        <v-select outlined
                                  dense
                                  v-if="can('admin')"
                                  label="Versions"
                                  :loading="isVersionsLoading"
                                  :items="versions"
                                  multiple
                                  v-model="filter.versions"
                                  class="mb-3"
                                  hide-details=""
                                  clearable
                                  chips
                                  small-chips
                                  deletable-chips
                        />
                      </v-col>
                      <v-col cols="6">
                        <v-select outlined
                                  dense
                                  label="Pays"
                                  :loading="isDBLoading"
                                  :items="countries"
                                  item-value="id"
                                  item-text="name"
                                  multiple
                                  v-model="filter.countries"
                                  class="mb-3"
                                  hide-details=""
                                  clearable
                                  chips
                                  small-chips
                                  deletable-chips
                        />
                      </v-col>
                      <v-col cols="6">
                        <v-autocomplete outlined
                                        dense
                                        hide-details
                                        label="Wilaya"
                                        clearable
                                        chips
                                        small-chips
                                        deletable-chips
                                        multiple
                                        v-model="filter.selectedWilayas"
                                        @change="filterRegion"
                                        :items="$store.state.wilayas"
                                        item-value="id"
                                        item-text="name"
                                        class="mb-3"
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="6">
                        <v-autocomplete outlined
                                        dense
                                        class="mb-3"
                                        hide-details
                                        label="Commune"
                                        :disabled="filter.selectedWilayas.length === 0"
                                        clearable
                                        chips
                                        small-chips
                                        deletable-chips
                                        multiple
                                        v-model="filter.selectedCommunes"
                                        :items="communes"
                                        item-value="id"
                                        item-text="name"
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="6">
                        <v-select outlined
                                  dense
                                  label="Base de données"
                                  :loading="isDBLoading"
                                  :items="databases"
                                  item-value="id"
                                  item-text="name"
                                  multiple
                                  v-model="filter.databases"
                                  class="mb-3"
                                  hide-details=""
                                  clearable
                                  chips
                                  small-chips
                                  deletable-chips
                        />
                      </v-col>
                      <v-col cols="6">
                        <v-select outlined
                                  dense
                                  v-if="can('admin')"
                                  label="Catégories"
                                  :loading="isCategoryLoading"
                                  :items="categories"
                                  item-value="id"
                                  item-text="name"
                                  multiple
                                  v-model="filter.categories"
                                  class="mb-3"
                                  hide-details=""
                                  clearable
                                  chips
                                  small-chips
                                  deletable-chips
                        />
                      </v-col>
                      <v-col cols="6">
                        <v-select outlined
                                  dense
                                  v-if="can('admin')"
                                  label="Role"
                                  :loading="isRoleLoading"
                                  :items="roles"
                                  item-value="id"
                                  item-text="name"
                                  multiple
                                  v-model="filter.roles"
                                  hide-details=""
                                  clearable
                                  chips
                                  small-chips
                                  deletable-chips
                                  class="mb-4"
                        />
                      </v-col>

                      <v-col cols="6">
                        <p class="text-left">
                          Montant:
                        </p>
                        <v-range-slider
                            v-if="!rangeLoading"
                            v-model="filter.range"
                            :max="max"
                            :min="0"
                            hide-details
                            class="align-center mt-5 pt-5 mb-4"
                            thumb-label="always"
                        >
                          <template v-slot:prepend>
                            <v-text-field
                                :value="filter.range[0]"
                                class="mt-0 pt-0"
                                hide-details
                                single-line
                                type="number"
                                style="width: 60px"
                                @change="$set(filter.range, 0, $event)"
                            ></v-text-field>
                          </template>

                          <template v-slot:thumb-label="item">
                            <v-btn
                                class="primary mt-4"
                                small
                                elevation="0"
                                style="font-size: 10px"
                            >
                              {{ CurrencyFormatting(item.value) }} DZ
                            </v-btn>
                          </template>

                          <template v-slot:append>
                            <v-text-field
                                :value="filter.range[1]"
                                class="mt-0 pt-0"
                                hide-details
                                single-line
                                type="number"
                                style="width: 80px"
                                @change="$set(filter.range, 1, $event)"
                            ></v-text-field>
                          </template>
                        </v-range-slider>

                        <v-progress-circular v-else
                                             indeterminate
                                             class="mt-4"
                                             color="amber"
                        ></v-progress-circular>

                      </v-col>
                    </v-row>


                    <div class="text-center  mt-5">
                      <v-btn depressed
                             color="gifty"
                             dark
                             type="submit"
                             :loading="btnLoading"
                      >
                        <v-icon left>mdi-magnify</v-icon>
                        Recherche
                      </v-btn>
                    </div>
                  </form>
                </v-card-text>

              </v-card>
            </v-tab-item>
            <v-tab-item value="tab-2" v-if="can('admin')">
              <v-card>
                <v-card-text>
                  <div v-if="isLoading">
                    <v-skeleton-loader type="table"></v-skeleton-loader>
                  </div>

                  <div v-else>
                    <div v-if="filtredUsers.length > 0">
                      <v-data-table
                          :items="filtredUsers"
                          :hide-default-header="false"
                          :hide-default-footer="false"
                          item-key="id"
                          class="elevation-0 table-border rounded-lg"
                      >
                        <template v-slot:item="{ item }">
                          <tr>

                            <td>
                              <v-checkbox color="success"
                                          hide-details
                                          class="pa-0 ma-0"
                                          v-model="selectedUsers"
                                          :value="item"
                                          :value-comparator="comparator"
                              />
                            </td>

                            <td>
                              {{ item.id }}
                            </td>

                            <td class="font-weight-bold text-no-wrap">
                              {{ item.name }}
                            </td>

                            <td class="text-no-wrap">
                              {{ item.phone }}
                            </td>

                            <td class="text-no-wrap">
                              {{ item.email }}
                            </td>

                          </tr>
                        </template>
                      </v-data-table>
                    </div>

                    <div v-else>
                      <div class="text-center">
                        <v-avatar tile size="200">
                          <v-img
                              :src="require('@/assets/database.svg')"
                          ></v-img>
                        </v-avatar>
                        <h3 class="text--primary d-block mb-2">OOPS !</h3>
                        <p>Aucun enregistrement correspondant trouvé.</p>
                      </div>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>

        <v-divider v-if="selectedUsers.length > 0"/>

        <v-card-actions v-if="selectedUsers.length > 0">

          <div>
            <p class="d-flex align-center mb-0">

              <v-icon color="primary" left size="20" v-if="selectedUsers.length">mdi-check-circle-outline</v-icon>

              <v-icon color="primary" left size="20" v-else>mdi-close-circle-outline</v-icon>

              <b> Utilisateurs : </b>
              <strong class="primary--text ml-2">
                {{ selectedUsers.length }}
              </strong>
            </p>

          </div>

          <v-spacer/>

          <v-btn color="gifty"
                 dark
                 v-if="ids.length"
                 depressed
                 @click="Validate">
            <v-icon left>mdi-check-circle</v-icon>
            Valider
          </v-btn>


        </v-card-actions>

      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {HTTP} from "@/http-common";

export default {
  data() {
    return {
      tab: null,
      btnLoading: false,
      isLoading: false,

      isDBLoading: false,
      isRoleLoading: false,
      isCategoryLoading: false,
      isCountriesLoading: false,
      isVersionsLoading: false,
      rangeLoading: true,

      countries: [],
      roles: [],
      categories: [],
      databases: [],
      versions: [],

      max: 1000,

      filter: {
        selectedWilayas: [],
        selectedCommunes: [],
        countries: [],
        roles: [],
        categories: [],
        databases: [],
        versions: [],
        range: [],
      },
      dialog: false,
      filtredUsers: [],

      selectedUsers: [],
      ids: [],
    };
  },
  methods: {
    filterUsers() {
      this.btnLoading = true;
      this.isLoading = true;
      //filter_users
      HTTP.post("/V2/publicities/filter_users", this.filter)
          .then((res) => {
            this.btnLoading = false;
            this.isLoading = false;
            this.selectedUsers = res.data.users;
            this.filtredUsers = res.data.users;
            this.ids = res.data.ids;
          })
          .catch((err) => {
            this.btnLoading = false;
            this.isLoading = false;
            this.formErrors = err.response.data.errors;
          });
    },
    open() {
      this.dialog = true;
      if (this.wilayas.length == 0) this.$store.dispatch("fetchwilayas");

      if (!this.roles.length) {
        this.getRoles();
      }
      if (!this.databases.length) {
        this.getDatabases();
      }

      if (!this.categories.length) {
        this.getCategories();
      }
      if (!this.countries.length) {
        this.getCountries();
      }
      if (!this.versions.length) {
        this.getVersions();
      }
      if (!this.filter.range.length) {
        this.getRange();
      }
    },
    close() {
      this.dialog = false;
    },

    Validate() {
      this.dialog = false;
      var ids = [];
      this.selectedUsers.forEach((element) => {
        ids.push(element.id);
      });
      this.$emit("selected", {
        users: ids,
        filter: JSON.stringify(this.filter)
      });
    },

    filterRegion() {
      var numeric_array = [];
      for (var item in this.filter.selectedWilayas) {
        numeric_array.push(this.filter.selectedWilayas[item]);
      }
      this.$store.dispatch("fetchCommunes", {
        filter: numeric_array,
      });
    },
    setUsers(users, ids, filter) {
      if (users != null) {
        this.selectedUsers = users;
        this.filtredUsers = users;
      } else {
        this.selectedUsers = [];
        this.filtredUsers = [];
      }

      this.ids = ids;

      if (filter) {
        this.filter = filter;
      }

      this.getRange();

    },
    comparator(a, b) {
      return a.id == b.id;
    },

    getCountries() {
      this.isCountriesLoading = true;
      HTTP.get("/v1/users/countries")
          .then((res) => {
            this.isCountriesLoading = false;
            this.countries = res.data.data;
          })
          .catch((err) => {
            this.isCountriesLoading = false;
            console.log(err);
          });
    },
    getCategories() {
      this.isCategoryLoading = true;
      HTTP.get("/v1/users/categories")
          .then((res) => {
            this.isCategoryLoading = false;
            this.categories = res.data.data;
          })
          .catch((err) => {
            this.isRoleLoading = false;
            console.log(err);
          });
    },

    getWilayas() {
      this.isWilayasLoading = true;
      HTTP.get("/v1/users/wilayas")
          .then((res) => {
            this.isWilayasLoading = false;
            this.wilayas = res.data.data;
          })
          .catch((err) => {
            this.isWilayasLoading = false;
            console.log(err);
          });
    },
    getRoles() {
      this.isRoleLoading = true;
      HTTP.get("/v1/users/roles")
          .then((res) => {
            this.isRoleLoading = false;
            this.roles = res.data.data;
          })
          .catch((err) => {
            this.isRoleLoading = false;
            console.log(err);
          });
    },
    getDatabases() {
      this.isDBLoading = true;
      HTTP.get("/v1/users/databases")
          .then((res) => {
            this.isDBLoading = false;
            this.databases = res.data.data;
          })
          .catch((err) => {
            this.isDBLoading = false;
            console.log(err);
          });
    },

    getVersions() {
      this.isVersionsLoading = true;
      HTTP.get("/v1/users/versions")
          .then((res) => {
            this.isVersionsLoading = false;
            this.versions = res.data.data;
          })
          .catch((err) => {
            this.isVersionsLoading = false;
            console.log(err);
          });
    },

    getRange() {
      this.rangeLoading = true;
      HTTP.get("v1/users/min_max_accounts")
          .then((res) => {
            this.max = res.data.max;
            this.filter.range = [res.data.min, res.data.max];

            this.rangeLoading = false;
          })
          .catch((err) => {
            console.log(err);
            this.rangeLoading = false;
          });
    },
  },
  computed: {
    wilayas() {
      return this.$store.getters.getWilayas;
    },

    communes() {
      return this.$store.getters.getCommunes;
    },
  },

  mounted() {
  },
};
</script>